module.exports = __webpack_public_path__ + "static/media/disclaimer_english.9a123ee7.md";